// Page context for attaching route identity to API telemetry.
//
// base.js stamps every api_request_* PostHog event with these values so the
// analytics side can answer "how many calls does StudentDashboard fire per
// load" without inferring from session timing. pageLoadId is a per-navigation
// UUID — multiple pageviews on the same path each get their own ID so we can
// count duplicate endpoint hits within a single load.

let currentPagePath = null;
let currentPageLoadId = null;

export function setPageContext(pagePath) {
  currentPagePath = pagePath;
  currentPageLoadId =
    typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
      ? crypto.randomUUID()
      : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
}

// Initialize synchronously at module load so the first burst of API calls —
// which fire from AuthContext on mount, BEFORE PageContextTracker's useEffect
// runs — get a real path stamped on their telemetry. PageContextTracker's
// effect then takes over for subsequent navigations.
if (typeof window !== 'undefined') {
  setPageContext(window.location.pathname);
}

export function getPageContext() {
  return { pagePath: currentPagePath, pageLoadId: currentPageLoadId };
}

export function __resetPageContext() {
  currentPagePath = null;
  currentPageLoadId = null;
}
